import ArrayField from './component';
import { ArrayFieldProps } from './types';

export type { ArrayFieldProps };
export default ArrayField;
